<script lang="ts">
  import BlankScreen from '@dabble/toolkit/BlankScreen.svelte';

  // Bounces a stale internal account/billing/checkout link out to the accounts app.
  export let to: () => string;

  location.replace(to());
</script>

<BlankScreen />
